"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortMultipartUploadOutput = {
    type: "structure",
    required: [],
    members: {
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=AbortMultipartUploadOutput.js.map